export * from "./model/openedCard.store";
